<template>
    <div>
        <myHead/>
        <div>
            <a-row type="flex" style="width:100%;margin-top:-2px;padding-left:20px;padding-right:20px">
                <a-col flex="auto">
                    <a-spin  :spinning="isLoading" >
                     <ul v-if="tableData.length>0" class="ant-list-items" style="line-height:40px"> 
                        <li @mouseenter="hoverIndex=i+1" @mouseleave="hoverIndex=0"  class="ant-list-item" v-for="(v,i) in tableData" :key="i" style="border-bottom: 1px solid #f0f0f0;">
                            <a-row style="width:100%">
                                <a-col :span="2" style="text-align:center;">
                                    <span style="width:80px;height:80px;" class="ant-avatar ant-avatar-lg ant-avatar-square ant-avatar-image">
                                        <svg t="1624775837237"    v-if="v.Type==1" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="9375"><path d="M376.3 296.6c29.1-49.5 39.8-99 39.8-99l84.2 34-24.5 48s6.1 6.2 27.5 3.1 162.2-74.3 258.6-57.2c97.7 17.3 157.6 94.4 157.6 154.7v289.3s-10.7 88.2-85.7 119.1c-75 30.9-189.7 7.7-189.7 7.7l6.1-48s68.9 15.5 111.7 1.5c42.8-13.9 55.1-48 55.1-48v-345s-6.1-35.6-45.9-60.3c-39.8-24.8-59.7-21.7-102.5-15.5-42.8 6.2-108.6 37.1-108.6 37.1l-36.7 72.7h247.9v49.5H619.6v61.9h157.6v43.3l-154.5 6.2v117.6l73.5-32.5-6.1-51.1 59.7-12.4 44.4 117.6-73.5 34-9.2-41.8s-138.9 59.2-194.6 63.8c-55.7 4.6-110.4-8.8-137-46.9-26.5-38.1-20.3-114.4-20.3-114.4l99 2.5s-7.7 43.5 11.8 71S534 680 534 680V548.8l-153-4.6v-41.8h154.5l-1.5-61.9-47.4-9.3s-39.8 61.9-65.8 60.3c-26-1.5-29.1-37.1-29.1-37.1l84.2-105.2-45.9-4.6-68.9 82-52-46.4c-0.1-0.1 38.2-34.1 67.2-83.6z m-175.9 64.9l-52 74.3s111.7 55.7 120.9 100.6c9.2 44.9-153 179.5-153 179.5l115.7 85s119.8-212 110.7-281.6-142.3-157.8-142.3-157.8z m62.3-31.5c37.8 0 68.4-31 68.4-69.1 0-38.2-30.6-69.1-68.4-69.1-37.8 0-68.4 31-68.4 69.1 0 38.2 30.6 69.1 68.4 69.1z" fill="#d81e06" p-id="9376"></path></svg>
                                        <svg t="1624775803922"   v-else-if="v.Type==2" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8657"><path d="M178.9 377.2c1.6 21.1 4 42.4 4.8 63.6 1.5 39.5-14.1 70.9-46.2 93.9-24.7 17.7-51.8 30.6-81.4 37.6-34.6 8.1-63.4-20.3-54.4-54.7C6.8 498 13.4 478 23.6 460.7c25.4-42.8 41-89.2 53.7-136.8 2.3-8.9 5.5-17.7 9.5-26 6.9-14.4 22.6-21.8 37.7-17.3 10.9 3.3 21.5 7.9 31.6 13.3 16.1 8.4 31.8 18 47.6 27.1 9.7-10.4 19-21.4 29.1-31.4 35.4-35.1 79-57.4 123.5-78 69.7-32.2 141.4-59.5 216.8-75.2 34.9-7.2 70.6-11.9 106.2-14.6 42.5-3.2 85.2-4.8 127.7-3.7 55.2 1.3 109.6 8.6 160 34 27.2 13.7 50 32.6 54.9 63.6 3.4 21.7 2.1 44.7-0.4 66.8-4.1 37.5-19.4 72-34.3 106.1-4 9-14.4 16.2-23.3 21.5-22.8 13.3-48.2 20.2-74 25.1-72.7 13.9-144.1 7.7-213.6-17.3-41.3-14.8-74.6-41.8-104.9-72.7-3.2-3.2-5.7-7.5-9.6-9.3-4.1-2-10.6-3.6-13.5-1.6-3 2.1-4.8 9-4 13.1 1.1 4.9 4.8 9.8 8.4 13.7 44 47.6 97.6 79.5 160.7 94.1 75.4 17.4 150.5 16.5 224.5-8.1 4.2-1.4 8.4-3 12.5-4.9 4-1.8 7.9-4 13.4-4.9-8.2 11.9-15.9 24-24.4 35.6-57.4 77-131.1 131.2-224 158.3-59.3 17.3-118.6 14.8-177.6 0.5-98.5-24-189-65.4-267-131.4-24.3-20.5-47.2-42.7-63.2-70.6-6.2-10.7-11.4-22.4-14.4-34.2-2.3-9.7-6.2-15.8-14.3-18.3z m717.2-235.3c-11.4 1.1-23 1.5-34.3 3.3-17.5 2.8-34.2 8.5-48.1 20-12.3 10-10.9 24.5 2.8 32.2 5.5 3 11.7 5.3 17.7 6.9 27.7 7.6 55.9 5.6 83.9 2.5 14.4-1.6 28.6-6.2 42.1-11.4 9.3-3.6 16.3-11.6 15.9-23-0.5-10.9-9.3-14.8-17.3-18.6-19.7-9.2-41-11.8-62.7-11.9zM567.3 269.7c16.6 0 29.5-11.7 29.5-26.4-0.1-14.6-13.7-26.7-29.7-26.6-16.7 0.1-29.2 11.6-29.3 26.6 0 14.7 12.9 26.3 29.5 26.4z m128.5 635.9c-7.7 0-15.1 0.5-22.3-0.2-2-0.2-4.7-3.6-5.3-6.1-5.4-21-9.9-42.4-15.8-63.3-2.2-8.2-6.4-16.1-11.2-23.2-7.2-10.9-19.4-12.3-27.5-2.1-7.9 9.8-14.9 20.9-19.8 32.6-7.1 17-12.3 34.9-17.3 52.8-2.1 7.4-4.7 11.2-12.8 9.9-4.6-0.7-9.5-0.1-15.2-0.1 1.2-30.6 2.2-60.2 3.4-92.6-7.2 3.6-12.7 5.4-16.9 8.6-9.7 7.8-19.3 15.9-28 24.7-15.9 16.2-31.3 33-46.7 49.8-9.7 10.5-13.1 11.6-29.8 7.7 19.7-33.5 39.3-66.7 59.5-100.6-19.4-5.6-36.3-13.3-43.5-33.2-4.6-12.4-3.9-24.6 1.2-37.4 1.2 4.3 2.1 8.8 3.4 13.1 6.5 22.3 26.1 33.9 48.2 27.2 5.7-1.8 12-6.5 15.2-11.6 19.4-31.3 38.1-63 56.5-94.8 3.4-5.8 6.8-6.9 13.1-5.8 30.4 4.8 60.8 9.3 91.4 1.3 6.7-1.8 13.1-4.6 20.2-7.1v250.4z" p-id="8658" fill="#d81e06"></path></svg>
                                        <svg t="1624775770374"   v-else-if="v.Type==3" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8132"><path d="M204.8 81.2c10.3-9 21.4-17 33.2-24.1v343.3c-51.2-36.1-99.3-75.3-150.5-111.5-30.1-21.1-57.2-42.1-87.3-63.2C69.4 177.6 135.8 129.3 205 81.2h-0.2z m-69.2 81.3c0 9.1-3.1 15.1-3.1 24.1-3.1 9.1 9.1 21.1 0 30.1-6 15.1-12 27.1-18 39.2-3.3 4.5-3.3 10.6 0 15.1 3.1 6 12 3.1 18 3.1 6 3.1 9.1 6 15.1 6s9.1-3.1 15.1-3.1 12 3.1 15.1 0c3.1 0 6-3.1 12-6h15c6-3.1 6-12 3.1-18-9.7-9.7-17.8-20.9-24.1-33.2-9.1-12 6-27.1 0-39.2-3.1-3.1-3.1-12-3.1-18h-6c-2.5 7.8-7.9 14.3-15.1 18-7.8-2.5-14.3-7.9-18-15.1 0-3.1-3.1-3.1-6-3.1v0.1zM256 57.2c30.1 21.1 60.3 42.1 93.3 63.2l153.6 108.4c-5.6 3.2-10.7 7.3-15.1 12-75.3 51.2-150.5 105.5-228.9 156.7C256 286 256 171.6 256 57.2z m24.1 129.5c3.3 7.4 7.4 14.5 12 21.1 3.1 0 6-3.1 9.1-3.1V277c27 3 54.3 3 81.3 0 1.5-24.1 1.5-48.2 0-72.3 3.1 0 6 3.1 9.1 3.1 6.7-6.8 11.9-15 15.1-24.1-15.1-3.1-30.1-12-45.2-15.1-3.2 9-11.6 15-21.1 15.1-9.1 0-15.1-9.1-18-15.1-14.8 4.2-28.9 10.2-42.1 18l-0.2 0.1zM521 231.9c81.4-60.3 165.8-117.5 247-174.7v340.4C686.7 343.2 602.4 286 521.1 231.9h-0.1z m132.4-69.3c-4.5 14.7-4.5 30.5 0 45.2 6 15.1 21.1 24.1 30.1 36.1 6 6 3.1 15.1 3.1 21.1-8.6 2.8-16.7 6.8-24.1 12h54.3c-9.1-3.1-15.1-9.1-24.1-12 0-6-3.1-18 3.1-21.1 13.1-9.1 23.5-21.6 30.1-36.1 6-15.1 0-30.1-3.1-45.2h-69.4zM783.1 57.2l63.2 45.2c51.2 36.1 99.3 69.2 150.5 105.5l27.1 18C942.6 283.1 864.3 340.3 783 400.6V57.2z m45.2 93.3c2.6 11.1 10.5 20.1 21.1 24.1h18c-3.1-6-3.1-15.1-9.1-18-9-9.2-21.1-6.1-30-6.1z m48.1 9.1c-3.7 4.6-6.7 9.7-9.1 15.1 6 0 15.1 0 18-3.1 3.7-4.6 6.8-9.7 9.1-15.1-6.1-0.5-12.3 0.6-18 3.1z m-18 21.1c-27.9 4.5-46.9 30.8-42.4 58.7 0.1 0.5 0.2 1.1 0.3 1.6 4.1 26.1 27.8 44.5 54.1 42.1 13.8-1.6 26.5-8 36.1-18 11.9-15.4 15.3-35.8 9.1-54.3-11-21-33.8-33-57.2-30.1z m-66.3 234.9c78.3-57.2 153.6-111.5 231.9-168.7v340.4C945.7 530 870.4 475.7 792.1 418.5c0 0-3.1-3.1 0-3.1v0.2z m123.5-33.2c-19.8 2.5-36.8 15.1-45.2 33.2-3.1 12 9.1 18 15.1 27.1 9.4 8 20.9 13.2 33.2 15.1 8.6 6.7 17.6 12.7 27.1 18 2.5-7.8 3.5-15.9 3.1-24.1 10.5-6.3 20.6-13.4 30.1-21.1 9.1 3.1 15.1 12 21.1 15.1 3.1 0 9.1 0 9.1-3.1-0.6-7.4-2.6-14.5-6-21.1 3.8-6.4 5.8-13.7 6-21.1 0-6-6-9.1-12-6-6.4 3.4-11.7 8.7-15.1 15.1-12-6-21.1-15.1-33.2-21.1v-24.1c-15.1 0-24.1 12-33.2 18l-0.1 0.1zM0 249.9c78.3 57.2 153.6 111.5 231.9 168.7 3.1 0 0 3.1 0 3.1C153.6 475.8 78.3 533.1 0 587.2V249.9z m69.2 117.5c-2.3 5.4-5.4 10.5-9.1 15.1-2.9 3.7-7.3 5.9-12 6-8.1 6.6-12.6 16.6-12 27-3 9.8-3 20.3 0 30.1 0.9 9.1 8.9 15.8 18 15.1h69.2c5.6-0.1 11-2.2 15.1-6 6-6 3.1-18 3.1-27.1-1.2-12.4-4.3-24.6-9.1-36.1-6.2-3.7-12.3-7.7-18-12-2.8-10.3-10.8-18.4-21.1-21.1-8.8 0.2-17.2 3.4-24.1 9z m349.4-21.1c12-15.1 15.1-33.2 24.1-48.1 8.3 14.5 15.3 29.6 21.1 45.2 6 0 12 3.1 21.1 3.1v17.9c9.1-3.1 18-3.1 30.1-6-6-21.1-15.1-42.1-21.1-60.3 21.1 9.1 39.2 15.1 57.2 24.1-6 12-9.1 27.1-15.1 42.1 9.1-3.1 18-3.1 24.1-6 3.1 0 3.1-3.1 6-6 8.3-17.6 15.4-35.7 21.1-54.3 15.1 9.1 27.1 21.1 42.1 30.1l-9.1 9.1c-9.1 9.1-21.1 15.1-30.1 24.1h39.2c3.1 9.1 6 21.1 9.1 30.1h-23.9c-3.1 12-6 24.1-9.1 39.2 11.4 1.6 22.5 4.7 33.2 9.1 5.8 9.2 9.9 19.4 12 30.1-12 3.1-27.1 3.1-39.2 6l-9.1 63.2c-6.3 6-13.4 11.1-21.1 15.1-6-27.1-9.1-54.3-15.1-81.3-9.2 0.5-18.3-0.6-27.1-3.1-6 21.1-9.1 45.2-15.1 66.3-6 9.1-15.1 9.1-24.1 15.1 0.5-26.1-0.5-52.3-3.1-78.3-6.2 0.4-12.4-0.6-18-3.1-3.1-9.1-6-15.1-9.1-24.1-12 12-9.1 30.1-12 45.2-3.1 21.1-6 42.1-9.1 60.3-16.8-11.1-32.8-23.1-48.1-36.1 9.1-3.1 21.1-6 30.1-9.1-3.1-15.1-3.1-30.1-6-45.2-6 3.1-12 9.1-18 12-6-15.1-9.1-33.2-15.1-48.1 11.3-0.3 22.5-2.3 33.2-6 0-12-3.1-21.1-3.1-33.2-3.1 0-6-3.1-9.1-3.1-6.7-9.6-12.7-19.7-18-30.1 8.4-0.2 16.6-2.3 24.1-6l0.1 0.1z m39.1 75.3h30.1l-9.1 18 27.1-9.1c-3.1-9.1-3.1-21.1-6-30.1-6-3.1-12-3.1-18-6-6-6-6-12-9.1-18-12 9.1-12 27.1-15.1 45.2h0.1z m87.3-24.1c-3.1 12-3.1 24.1-6 36.1 12-3.1 21.1-3.1 33.2-6 0-12-3.1-24.1-3.1-33.2-8.2-0.4-16.3 0.6-24.1 3.1zM84.2 367.4c9.1-3.1 18 6 21.1 15.1H69.2c6-6 9.1-12 15.1-15.1h-0.1z m448.9 240.9L768 436.7V780l-72.3-54.3c-54.3-39.2-108.4-81.3-162.7-117.5l0.1 0.1z m141.6-69.2c-3.1 6-3.1 15.1-6 21.1 6-3.1 12-3.1 18-6 10.4-2.4 21.4-0.2 30.1 6-3.1-6-3.1-15.1-6-21.1h-36.1z m6 27.1c-12.2 3.6-22.1 12.4-27.1 24.1-4.8 17.4 2.6 35.9 18 45.2 14.7 8.6 33.3 6.1 45.2-6 15.1-12.7 17.1-35.2 4.4-50.3-3.6-4.4-8.3-7.8-13.5-10-9.1-6-18-3.1-27.1-3.1l0.1 0.1z m-12 78.3c3.1 6 3.1 15.1 6 21.1h33.2c2.4-6.9 4.4-14 6-21.1-12.1 9.1-30.1 6.1-45.2 0z m114.4-210.8c81.3 57.1 159.6 111.4 240.9 168.6l-126.5 90.4C861.4 719.8 822.2 747 786 774c-3-111.5-3-226-3-340.4l0.1 0.1z m78.3 96.4v24.1h9c3.1-6 0-9.1 0-15.1 6-9.1-6-6-9.1-9.1l0.1 0.1z m-33.1 3.1v21.1c3.1 0 6 3.1 9.1 3.1-3.1-9.1 6-24.1-9.1-24.1v-0.1z m69.2 0c-3.1 6 0 12 0 18 0 3.1 9.1 3.1 9.1 0 3.1-6 0-12 0-18h-9.1z m-78.3 32.9v87.3c0 3.1 6 6 9.1 6h69.2c6 0 12 3.1 15.1-3.1 2.5-5.7 3.5-11.9 3.1-18 6-3.1 9.1-3.1 15.1-6 9.5-6.9 12.1-20 6-30.1-6-7.7-14.5-13.1-24.1-15.1v-21h-93.5zM0 602.3C78.3 548 156.7 490.8 238 436.7V777c-48.1-33.2-93.3-69.2-141.6-105.5-33.2-24-66.3-45.1-96.4-69.2z m198.8-57.2c-6 9.1-15.1 15.1-18 24.1-9.1 15.1-12 33.2-24.1 48.1-18 6-42.1 6-57.2 24.1 17.6 12.2 39.9 15.5 60.3 9.1 12-3.1 15.1-15.1 18-24.1 1.3-11.5 6.6-22.2 15.1-30.1 3.1-3.1 6 3.1 6 6v51.2h5.9c0-18-3.1-39.2 6-57.2 5.1-9.1 7.2-19.7 6-30.1-3.4-8.9-9.8-16.3-18-21.1zM256 436.7c48.1 33.2 93.3 66.3 138.5 102.4 30.1 24.1 63.2 45.2 93.3 69.2C409.6 665.5 331.3 722.8 256 780V436.7z m66.3 111.5c-6 3.1-6 9.1-12 12-8.1-0.5-16.3 0.6-24.1 3.1-3.1 0-6 6-6 9.1v69.2c0 6 9.1 6 12 6h99.3c6 0 6-6 6-12v-69.5c-8.2-4.8-17.7-6.9-27.1-6-3.6-5.6-8.9-9.8-15.1-12l-33 0.1zM265.1 792c81.3-57.2 159.6-114.4 240.9-168.7V804c3.1 54.3 0 108.4 0 159.6-57.2-39.2-111.5-81.3-168.7-120.4-24.1-18-51.2-36.1-72.3-51.2h0.1z m150.5-66.3h12c-3.1-3.1-3.1-6-6-6l-6 6z m-42.1 27.1c-7.8 11.1-13.9 23.2-18 36.1 3.1 0 9.1-3.1 12-3.1 9.1 0 18 3.1 24.1 0 6.7-3 14.4-3 21.1 0 0.5 16.2-0.5 32.4-3.1 48.4 0 6-9.1 6-12 6l-9.1-18c-3.1 3.1-6 3.1-6 6-1.3 10.6 5 20.6 15.1 24.1 11.3 3.5 23.4-2.9 26.9-14.2l0.3-0.9V786c9.1-2 18.7-0.9 27.1 3.1 10.8-3 22.3-3 33.2 0-1.9-12.2-7.1-23.7-15.1-33.2-5.7-6.7-13-11.9-21.1-15.1-24.2-17.5-57.9-12.1-75.4 12z m147.6-129.4c81.3 57.2 159.6 111.5 240.9 168.7-78.3 57.2-159.6 117.5-238 174.7-3-117.5-3-231.9-3-343.2l0.1-0.2z m78.3 96.4c-3.1 3.1-3.1 9.1-9.1 9.1-9.1 6-18 15.1-27.1 21.1 3.5 2.4 7.8 3.5 12 3.1h66.3c-6-9.1-15.1-12-21.1-18-9.1-6-15.1-12-21.1-15.1l0.1-0.2z m-36.2 45.1v63.2c0 3.1 0 9.1 6 9.1h69.2c2.5-8.8 3.5-18 3.1-27.1v-45.2c0-3.1-6-3.1-9.1-3.1-23.1-0.6-46.2 0.4-69.2 3.1z" p-id="8133" fill="#d81e06"></path></svg>
                                        <svg t="1624775121852" v-else-if="v.Type==5" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="7433" ><path d="M602.9 669.8c-37.2 2.6-33.6-17.3-11.5-46.2 50.4-67.2 143.7-158.5 147.9-225.2 5.8-86.6-81.3-113.4-171-113.4-62.4 1.6-127 18.9-171 34.6-151.6 53.5-246.6 137.5-306.9 232-62.4 93.4-43 183.2 91.8 185.8 101.8-4.2 170.5-32.5 239.7-68.2 0.5 0-192.5 55.1-263.9 14.7-7.9-4.2-15.7-10-17.8-26.2 0-33.1 54.6-67.7 86.6-78.7v-56.7c64.5 22.6 140.6 16.3 205.7-32 2.1 5.8 4.2 13.1 3.7 21h11c2.6-22.6-12.6-44.6-37.8-46.2 7.3 5.8 12.6 10.5 15.2 14.7l-1 1-0.5 0.5c-83.9 58.8-165.3 31.5-173.1 29.9l46.7-45.7-13.1-33.1c92.9-32.5 169.5-56.2 296.9-78.7l-28.5-23 14.7-8.9c75.5 21 126.4 36.7 123.8 76.6-1 6.8-3.7 14.7-7.9 23.1C660.1 466.1 594 538 567.2 569c-17.3 20.5-34.6 39.4-46.7 58.3-13.6 19.4-20.5 37.3-21 53.5 2.6 131.8 391.4-61.9 468-112.9-111.7 47.8-232.9 93.5-364.6 101.9z m85-302.9c2.8 5.2 4.1 11.6 4.1 19.1-0.1-6.8-1.4-13.3-4.1-19.1z" p-id="7434" fill="#d81e06"></path></svg>
                                        <svg t="1624880877574" v-else class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1814" ><path d="M937.4 423.9c-84 0-165.7-27.3-232.9-77.8v352.3c0 179.9-138.6 325.6-309.6 325.6S85.3 878.3 85.3 698.4c0-179.9 138.6-325.6 309.6-325.6 17.1 0 33.7 1.5 49.9 4.3v186.6c-15.5-6.1-32-9.2-48.6-9.2-76.3 0-138.2 65-138.2 145.3 0 80.2 61.9 145.3 138.2 145.3 76.2 0 138.1-65.1 138.1-145.3V0H707c0 134.5 103.7 243.5 231.6 243.5v180.3l-1.2 0.1" p-id="1815" fill="#d81e06"></path></svg>
                                    </span>
                                </a-col>
                                <a-col :span="14">
                                    <h3 class="ant-list-item-meta-title" style="font-weight:700;line-height:40px">
                                        <a  target="_blank" :href="v.HomeUrl">{{v.Name}}</a>
                                        
                                        <span style="float:right;margin-right:40px;font-weight:100;font-size:13px">
                                            <a-tooltip  placement="bottom">
                                                <template #title>
                                                    <div style="font-size:14px;width:400px;letter-spacing:2px">
                                                        <template  v-for="(vv,ii) in v.CommissionDetails" :key="ii">
                                                            <div style="display: inline-block;padding:5px;width:120px">
                                                                ≤{{vv.CriticalValue}}:￥{{vv.Commission}}
                                                            </div>
                                                            <br v-if="(ii+1)%2==0" />
                                                        </template>
                                                    </div>
                                                </template>
                                                <a >
                                                    <GroupOutlined /> 佣金
                                                </a>
                                            </a-tooltip>
                                        </span>
                                        
                                        <!-- <span style="float:right;margin-right:40px;font-weight:100;font-size:13px">
                                            <a-tooltip placement="bottom">
                                                <template #title>
                                                    <span>有社会关系的不同买手指定时间内不允许重复下单</span>
                                                </template>
                                                <QuestionCircleOutlined /> 
                                            </a-tooltip>
                                            关联复购限制 [<b style="color:#f082ac;">{{v.RelatedRepurchase}}</b>] 天
                                        </span>
                                        <span style="float:right;margin-right:40px;font-weight:100;font-size:13px">
                                            <a-tooltip placement="bottom">
                                                <template #title>
                                                    <span>同一买手指定时间内不允许重复下单</span>
                                                </template>
                                                <QuestionCircleOutlined /> 
                                            </a-tooltip>
                                            复购限制 [<b style="color:#f082ac;">{{v.Repurchase}}</b>] 天
                                        </span> -->
                                    </h3>

                                    <div class="ant-list-item-meta-description" style="line-height:40px">
                                        <UserOutlined /> {{v.Sender}}
                                        <MobileOutlined  style="margin-left:20px" /> {{v.SenderPhone}} 
                                      <EnvironmentOutlined style="margin-left:20px" /> {{v.SenderArea+ v.SenderAddress}}  
                                    </div>
                                </a-col>
                                <a-col :span="4">
                                    <div class="list-content-item" style="margin-left:0px">
                                        <div>
                                            <AliwangwangOutlined /> {{v.AliTrademanager}}
                                        </div>
                                        <div>
                                            <a-tag color="#67C23A" v-if="v.Status==2">正常</a-tag>
                                            <a-tag color="#F56C6C" v-else-if="v.Status==3">不通过</a-tag>
                                            <a-tag color="#E6A23C" v-else-if="v.Status==1">审核中</a-tag>
                                            <a-tag color="#909399" v-else>关闭</a-tag>

                                        </div>
                                    </div>
                                </a-col>
                                <a-col :span="2">
                                    <div class="list-content-item" style="margin-left:0px">
                                        <div>
                                            <ClockCircleOutlined /> 绑定时间
                                        </div>
                                        <div>
                                            {{v.CreateTime.split(' ')[0]}}
                                        </div>
                                    </div>
                                </a-col>
                                <a-col :span="2" style="line-height:80px;text-align:center">
                                    <a-button  @click="update(v)"   class="loginBtn animate__animated" v-show="hoverIndex==i+1"  :class="'animate__fadeInUp'"  shape="round" style=" opacity: 0;" >
                                        <template #icon>
                                        <FormOutlined /> 修改
                                        </template>
                                    </a-button>
                                </a-col>
                            </a-row>
                        </li>
                    </ul>
                    <div v-else style="height:500px">
                          <a-empty  description="暂无数据" style="margin-top:10%"/>
                    </div>
                    </a-spin>
                </a-col>
                <a-col flex="360px" style="padding-top:20px">
                    <a-card style="border-radius:25px; margin-left:10%">
                        <div class="queryDiv">
                            筛选
                            <a-input :allowClear="true" v-model:value="queryModel.queryTxt" style="margin-top:20px;font-size:14px" size="large" placeholder="请输入店铺名称" />
                            <!-- <input style="margin-top:20px"  v-model="queryModel.queryTxt"  type="text"  placeholder="请输入店铺名称"  class="text-input" autocorrect="off" autocapitalize="off"> -->
                            <a-divider  />
                            类型
                            <div style="margin-top:10px">
                                <a-radio-group v-model:value="queryModel.type">
                                    <a-radio style="display:block;line-height:30px;" :value="1">淘宝</a-radio>
                                    <a-radio style="display:block;line-height:30px;" :value="2">京东</a-radio>
                                    <a-radio style="display:block;line-height:30px;" :value="3">拼多多</a-radio>
                                    <a-radio style="display:block;line-height:30px;" :value="5">阿里巴巴</a-radio>
                                    <a-radio style="display:block;line-height:30px;" :value="6"  >抖音</a-radio>
                                </a-radio-group>
                            </div>
                            <a-divider  />
                            状态
                            <div style="margin-top:10px">
                                <a-radio-group v-model:value="queryModel.status">
                                    <a-radio style="display:block;line-height:30px;" :value="2">正常</a-radio>
                                    <a-radio style="display:block;line-height:30px;" :value="1">审核中</a-radio>
                                    <a-radio style="display:block;line-height:30px;" :value="3">不通过</a-radio>
                                </a-radio-group>
                            </div>
                             <a-divider  />
                        <a-button @click="query"  class="otherBtn" style="width:100%">
                            
                            <!-- <SearchOutlined /> -->
                            搜索
                        </a-button>
                        <a-button @click="addAction"  class="loginBtn" style="width:100%">
                            <!-- <PlusOutlined /> -->
                            绑定新店铺
                        </a-button>

                        </div>
                    </a-card>
                </a-col>
            </a-row>
        </div>
        <myFooter/>

<a-drawer
    :title="actionType"
    :width="720"
    :visible="shopVisible"
    :body-style="{ paddingBottom: '80px' }"
    @close="shopVisible=false"
  >
    <a-form :model="form" ref="formRef" :rules="rules" layout="vertical">
      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-item label="店铺名称" name="Name">
            <a-input :readonly="form.Id>0"  v-model:value="form.Name" placeholder="请输入店铺名称" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
        <a-form-item label="店铺类型" name="Type">
            <a-select :disabled="form.Id>0" v-model:value="form.Type" placeholder="请选择店铺类型" >
              <a-select-option :value="1">淘宝</a-select-option>
              <a-select-option :value="2">京东</a-select-option>
              <a-select-option :value="3">拼多多</a-select-option>
              <a-select-option :value="5">阿里巴巴</a-select-option>
              <a-select-option :value="6">抖音</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="12">
            <a-form-item label="首页地址" name="HomeUrl">
                <a-input-search :readonly="form.Id>0" @search="openUrl" v-model:value="form.HomeUrl" placeholder="请输入首页地址">
                    <template #enterButton>
                        <a-button >跳转</a-button>
                    </template>
                </a-input-search>
            </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="阿里旺旺" name="AliTrademanager">
                <a-input :readonly="form.Id>0" v-model:value="form.AliTrademanager" placeholder="请输入阿里旺旺"/>
            </a-form-item>
        </a-col>
      </a-row>
    <!-- <a-row :gutter="16">
        <a-col :span="12">
            <a-form-item label="复购限制天数（修改请联系客服）" name="Repurchase">
                <a-input-number :readonly="true" style="width:100%" v-model:value="form.Repurchase" placeholder="请输入复购限制天数"  :min="7" :max="90" />
            </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="关联复购限制天数（修改请联系客服）" name="RelatedRepurchase">
                <a-input-number :readonly="true" style="width:100%"  v-model:value="form.RelatedRepurchase" placeholder="请输入复购限制天数"  :min="7" :max="90" />
            </a-form-item>
        </a-col>
      </a-row> -->

        <a-row :gutter="16">
            <a-col :span="12">
                <a-form-item label="发货人" name="Sender">
                    <a-input v-model:value="form.Sender" placeholder="请输入发货人"/>
                </a-form-item>
            </a-col>
            <a-col :span="12">
            <a-form-item label="发货人手机号" name="SenderPhone">
                    <a-input v-model:value="form.SenderPhone" placeholder="请输入发货人手机号"/>
                </a-form-item>
            </a-col>
        </a-row>
        <a-row :gutter="16">
            <a-col :span="24">
                <a-form-item label="发货区域">
                    <a-row>
                        <a-col :span="8">
                            <a-select style="padding-left:0px" @change="getAreaTwo" v-model:value="form.SenderArea[0]" placeholder="请选择省份" >
                                <a-select-option 
                                v-for="v in areaOne" 
                                :key="v.Name"
                                :value="v.Name">{{v.Name}}</a-select-option>
                            </a-select>
                        </a-col>
                        <a-col :span="8">
                            <a-select style="padding-left:20px" @change="getAreaThree" v-model:value="form.SenderArea[1]" placeholder="请选择城市" >
                                <a-select-option  
                                v-for="v in areaTwo" 
                                :key="v.Name"
                                :value="v.Name" >{{v.Name}}</a-select-option>
                            </a-select>
                        </a-col>
                        <a-col :span="8">
                            <a-select  style="padding-left:20px" v-model:value="form.SenderArea[2]" placeholder="请选择区域" >
                                <a-select-option  
                                v-for="v in areaThree" 
                                :key="v.Name"
                                :value="v.Name"   >{{v.Name}}</a-select-option>
                            </a-select>
                        </a-col>
                    </a-row>
                </a-form-item>
            </a-col>
        </a-row>
        <a-row :gutter="16">
            <a-col :span="24">
                <a-form-item label="发货详细地址" name="SenderAddress">
                    <a-input v-model:value="form.SenderAddress" placeholder="请输入发货详细地址"/>
                </a-form-item>
            </a-col>
        </a-row>
        <a-row :gutter="16">
            <a-col :span="24">
                <a-form-item label="店铺截图" name="ImgSrc">
                    <a-upload
                    :disabled="form.Id>0"
                     accept="image/gif,image/jpeg,image/jpg,image/png,image/svg"
                            name="avatar"
                            list-type="picture-card"
                            class="avatar-uploader"
                            :show-upload-list="false"
                            :action="baseUrl+'/Account/PushImg'"
                            @change="handleChange"
                        >
                            <img style="width:102px;height:102px" v-if="form.ImgSrc" :src="form.ImgSrc" alt="avatar" />
                            <div v-else>
                            <template v-if="uploading">
                                <a-spin size="small" />
                            </template>
                            <plus-outlined v-else>
                                <PlusOutlined   />
                            </plus-outlined> 
                            </div>
                        </a-upload>
                        <a style="color:#ea4c89;" @click="isPreview=true">查看截图示例</a>
                </a-form-item>
            </a-col>
        </a-row>
    </a-form>
    <div
      :style="{
        position: 'absolute',
        right: 0,
        bottom: 0,
        width: '100%',
        borderTop: '1px solid #e9e9e9',
        padding: '10px 16px',
        background: '#fff',
        textAlign: 'right',
        zIndex: 1,
      }"
    >
      <a-button style="margin-right: 8px" @click="shopVisible=false">取消</a-button>
      <a-button type="primary" @click="sumbitShop">确定</a-button>
    </div>
  </a-drawer>
   <myPreview   v-model:show="isPreview" :src="'https://hlqimg.oss-cn-heyuan.aliyuncs.com/banner/shili.png'" />
    </div>
</template>

<script>
import { MobileOutlined,AliwangwangOutlined,ClockCircleOutlined,EnvironmentOutlined,FormOutlined,UserOutlined,GroupOutlined,PlusOutlined} from '@ant-design/icons-vue';
import { message } from 'ant-design-vue';

import myHead from '../components/myHead'
import myFooter from '../components/myFooter'
 import myPreview from '../components/myPreview'

import { shopGet,areaGet,uri,shopUpdate,shopAdd } from '@/request.js'
export default {
    
    components:{ myPreview,myFooter, myHead,MobileOutlined,AliwangwangOutlined,EnvironmentOutlined,ClockCircleOutlined,FormOutlined,UserOutlined,GroupOutlined,PlusOutlined},
    data() {
        return {
            isPreview:false,
            actionType:"绑定新店铺",
            setRow:{},
            baseUrl:uri,
            areaOne:[],
            areaTwo:[],
            areaThree:[],
            uploading:false,
            form:{
                Id:0,
                Type:1,
                Name:"",
                HomeUrl:"",
                AliTrademanager:"",
                Sender:"",
                SenderPhone:"",
                SenderArea:["北京市","北京城区","东城区"],
                SenderAddress:"",
                ImgSrc:"",
                Repurchase:0,
                RelatedRepurchase:0,
            },
            shopVisible:false,
            hoverIndex:0,
            isLoading:false,
            checkedList:[],
            tableData:[],
            queryModel:{
                queryTxt:"",
                status:"",
                type:"",
            },
            rules:{
                Name:[{required:true,message:'请填写店铺名称'}],
                Type:[{required:true,message:'请选择店铺类型',type:'number'}],
                HomeUrl:[{required:true,message:'请填写首页链接'}],
                AliTrademanager:[{required:true,message:'请填写掌柜旺旺'}],
                Sender:[{required:true,message:'请填写发货人'}],
                SenderPhone:[{required:true,message:'请填写发货人手机号'}],
                SenderArea:[{required:true,message:'请选择发货区域'}],
                SenderAddress:[{required:true,message:'请填写发货详细地址'}],
                ImgSrc:[{required:true,message:'请上传店铺后台截图用于验证'}],
                Repurchase:[{required:true,message:'请填写复购天数限制',type:'number'}],
                RelatedRepurchase:[{required:true,message:'请填写关联复购天数限制',type:'number'}],
            }
        };
    },
    methods: {
        sumbitShop(){
            this.$refs.formRef
            .validate()
            .then(() => {
                if(this.form.Id>0){
                    shopUpdate({
                        Id:this.form.Id,
                        Sender:this.form.Sender,
                        SenderPhone:this.form.SenderPhone,
                        SenderArea:this.form.SenderArea[0]+","+this.form.SenderArea[1]+","+this.form.SenderArea[2],
                        SenderAddress:this.form.SenderAddress,
                        Repurchase:this.form.Repurchase,
                        RelatedRepurchase:this.form.RelatedRepurchase,
                    },(res)=>{
                        if(res.IsSuccess){
                            this.setRow.Sender=this.form.Sender;
                            this.setRow.SenderPhone=this.form.SenderPhone;
                            this.setRow.SenderArea=this.form.SenderArea[0]+","+this.form.SenderArea[1]+","+this.form.SenderArea[2];
                            this.setRow.SenderAddress=this.form.SenderAddress;
                            this.setRow.Repurchase=this.form.Repurchase;
                            this.setRow.RelatedRepurchase=this.form.RelatedRepurchase;
                            this.shopVisible=false;
                            message.success("修改成功");
                        }else{
                            message.error(res.Message);
                        }
                    })
                }else{
                    shopAdd({
                        Id:0,
                        Sender:this.form.Sender,
                        SenderPhone:this.form.SenderPhone,
                        SenderArea:this.form.SenderArea[0]+","+this.form.SenderArea[1]+","+this.form.SenderArea[2],
                        SenderAddress:this.form.SenderAddress,
                        Type:this.form.Type,
                        Name:this.form.Name,
                        HomeUrl:this.form.HomeUrl,
                        AliTrademanager:this.form.AliTrademanager,
                        ImgSrc:this.form.ImgSrc,
                        Repurchase:this.form.Repurchase,
                        RelatedRepurchase:this.form.RelatedRepurchase,
                    },(res)=>{
                        if(res.IsSuccess){
                            this.shopVisible=false;
                            this.query();
                            message.success("添加成功");
                        }else{
                            message.error(res.Message);
                        }
                    })
                }
            })
            .catch(error => {
                 console.log('error', error);
            });

        },
        handleChange(info){
            if(info.file.status=="uploading"){
                this.uploading=true;
            }else{
                if(info.file.response){
                    var res=info.file.response;
                    if(res.IsSuccess){
                        this.uploading=false;
                        this.form.ImgSrc= res.Message;
                    }else{
                        message.error(res.Message);
                    }
                }
            }
        },
        openUrl(url){
            window.open(url);
        },
        update(v){
            this.actionType="编辑店铺信息";
            this.setRow=v;
            this.form={
                Id:v.Id,
                Type:v.Type,
                Name:v.Name,
                HomeUrl:v.HomeUrl,
                AliTrademanager:v.AliTrademanager,
                Sender:v.Sender,
                SenderPhone:v.SenderPhone,
                SenderArea:v.SenderArea.split(','),
                SenderAddress:v.SenderAddress,
                ImgSrc:v.ImgSrc,
                Repurchase:v.Repurchase,
                RelatedRepurchase:v.RelatedRepurchase,
            }
            this.getAreaTwo();
            this.shopVisible=true;
        },
        getAreaTwo(){
            areaGet({
                parentId:this.areaOne.find((element) => (element.Name == this.form.SenderArea[0])).Id
            },(res)=>{
                this.areaTwo=res.Result;
                this.form.SenderArea[1]=this.areaTwo[0].Name;
                this.getAreaThree();
            });
        },
        getAreaThree(){
            areaGet({
                parentId:this.areaTwo.find((element) => (element.Name == this.form.SenderArea[1])).Id
            },(res)=>{
                this.areaThree=res.Result;
                this.form.SenderArea[2]=this.areaThree[0].Name;
            });
        },

        addAction(){
            this.actionType="绑定新店铺";
            this.form={
                Id:0,
                Type:1,
                Name:"",
                HomeUrl:"",
                AliTrademanager:"",
                Sender:"",
                SenderPhone:"",
                SenderArea:["北京市","北京城区","东城区"],
                SenderAddress:"",
                ImgSrc:"",
                Repurchase:35,
                RelatedRepurchase:30,
            }
            this.shopVisible=true;
        },
        to(path){
            this.$router.push(path)
        },
        query(){
            this.isLoading=true;
            shopGet({
               queryTxt:this.queryModel.queryTxt,
               status:this.queryModel.status==""?0:parseInt(this.queryModel.status),
               type:this.queryModel.type==""?0:parseInt(this.queryModel.type)
           },(res)=>{
               this.tableData=res.Result;
               this.isLoading=false;
           })
        },
    },
    created(){
    },
    mounted() {
        this.query();
        areaGet({parentId: -1},(res)=>{
            this.areaOne=res.Result;
        });
        
    }
};
</script>
<style scoped>
.queryDiv{
    padding-left:8%;
    padding-right:8%;
    font-family: "Haas Grot Text R Web", "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-size: 16px;
    font-weight: 500;
    line-height: 22px;
    color: #0d0c22;
    display: block;
    margin-bottom: 10px;
}
.list-content-item{
   
    display: inline-block;
    margin-left: 40px;
    color: rgba(0,0,0,.45);
    font-size: 14px;
    vertical-align: middle;
}
</style>